/* eslint-disable no-param-reassign */
import MapMarker from '@Core/components/map/mapMarker';
import Events from './events';

export default class Location {
  id;
  map;
  coordinates;
  bounds;
  marker;
  distanceFromUser;
  departments;
  card;

  hiddenClass = 'hide';

  constructor(cardEl, departments = []) {
    this.card = cardEl;
    this.id = parseInt(cardEl.id.replace('location_', ''));
    this.marker = this.#buildMapMarker();
    this.distanceEls = cardEl.querySelectorAll('[data-distance-display]');
    this.departments = departments;
  }

  hasVehicleType(vehicleType) {
    const vehicleTypes = this.departments
      .map((department) => department.vehicleTypes)
      .flat();

    return vehicleTypes.includes(vehicleType);
  }

  hasDepartment(departmentType) {
    const departmentIndex = this.departments.findIndex(
      (department) => department.type === departmentType,
    );

    return departmentIndex >= 0;
  }

  hasDepartmentWithVehicleType(targetDepartment, targetVehicleType) {
    const departmentIndex = this.departments.findIndex((department) => {
      const hasDepartment = department.type === targetDepartment;
      const departmentHasVehicleType = department.vehicleTypes.includes(targetVehicleType);

      return hasDepartment && departmentHasVehicleType;
    });

    return departmentIndex >= 0;
  }

  activate() {
    this.marker.openPopup();
    this.isActive = true;
  }

  deactivate(options = {}) {
    const keepPopupOpen = options.keepPopupOpen || false;

    if (!keepPopupOpen) {
      this.marker.closePopup();
    }

    this.isActive = false;
  }

  hide() {
    this.card.classList.add(this.hiddenClass);
    this.marker.remove();
  }

  show() {
    this.card.classList.remove(this.hiddenClass);
  }

  isHidden() {
    return this.card.classList.contains(this.hiddenClass);
  }

  scrollTo() {
    const { offsetTop } = this.card;
    const listingCardBorderThickness = 1;
    const scrollY = offsetTop - listingCardBorderThickness;

    this.card.parentElement.scrollTo(0, scrollY);
  }

  updateDistance() {
    if (!this.marker?.distanceFromUser) return;

    const distance = this.marker.distanceFromUser.toFixed(1);
    this.distanceFromUser = distance;

    this.distanceEls.forEach((el) => {
      el.innerHTML = `&nbsp;(${distance} miles)`;
      el.classList.add('location-listing__distance');
    });
  }

  get isActive() {
    return this.card.dataset.isActive === 'true';
  }

  set isActive(value) {
    this.card.dataset.isActive = value;
  }

  #buildMapMarker() {
    return new MapMarker(this.card.dataset);
  }

  attachListeners() {
    this.card.addEventListener('click', () => {
      if (this.isActive) return;

      this.activate();
      window.dispatchEvent(Events.LocationSelected(this));
    });

    window.addEventListener('location-selected', (e) => {
      const selectedLocation = e.detail;

      if (this.id !== selectedLocation.id) {
        this.deactivate();
      }
    });
  }

  mount() {
    this.attachListeners();

    return this;
  }
}
